import { MatDialog } from '@angular/material';
import { AlertComponent } from './alert.component';
import { AlertTemplate } from './alert.template';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/dialog";
import * as i2 from "./alert.template";
var AlertService = /** @class */ (function () {
    function AlertService(dialog, alertTemplate) {
        this.dialog = dialog;
        this.alertTemplate = alertTemplate;
    }
    AlertService.prototype.openInfoModal = function (id, language) {
        this.dialog.closeAll();
        var template = this.alertTemplate.template(id, language);
        this.dialog.open(AlertComponent, {
            data: {
                title: template[0].title,
                html: template[0].html
            }
        });
    };
    AlertService.prototype.openInfoSessionModal = function (id, language) {
        this.dialog.closeAll();
        var template = this.alertTemplate.template(id, language);
        this.dialog.open(AlertComponent, {
            disableClose: true,
            data: {
                title: template[0].title,
                html: template[0].html
            }
        });
    };
    AlertService.prototype.openResponseModal = function (title, message) {
        this.dialog.closeAll();
        this.dialog.open(AlertComponent, {
            data: {
                title: title,
                html: message
            }
        });
    };
    AlertService.prototype.openConfirmModal = function (title, html) {
        this.dialog.closeAll();
        this.dialog.open(AlertComponent, {
            data: {
                title: title,
                html: html
            }
        });
    };
    AlertService.ngInjectableDef = i0.defineInjectable({ factory: function AlertService_Factory() { return new AlertService(i0.inject(i1.MatDialog), i0.inject(i2.AlertTemplate)); }, token: AlertService, providedIn: "root" });
    return AlertService;
}());
export { AlertService };
